<template>
    <span>
        <button v-if="mode == 'new'" class="btn btn-success btn-rounded px-4 rounded-pill"
            v-b-modal="'messageModal' + _uid"><i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új
            rendszerüzenet</button>
        <button v-else class="btn btn-primary btn-sm" v-b-modal="'messageModal' + _uid" title="szerkesztés"><i
                class="fa fa-pencil fa-xs"></i></button>
        <b-modal size="xl" :id="'messageModal' + _uid" cancel-variant="default" @cancel="closeMessageModal()"
            @ok="formHandler" ok-title="Mentés" cancel-title="Mégse" :ok-disabled="loading">
            <template slot="modal-header">
                <h4 class="modal-title">
                    {{ mode === 'new' ? 'Új rendszerüzenet létrehozása' : 'Rendszerüzenet szerkesztése' }}
                </h4>
                <a class="btn-close" @click="closeMessageModal()"></a>
            </template>
            <form @submit.prevent="formHandler()">
                <div class="row">
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label">Megnevezés</label>
                            <textarea class="form-control" v-model="form.message" style="height:30vh"></textarea>
                            <div v-if="errors.message" class="invalid-feedback d-block">{{ errors.message[0] }}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col">
                                <div class="mb-3">
                                    <label class="form-label">Prioritás:</label>
                                    <div class="form-group">
                                        <v-select v-model="form.priority" :options="priorities" :reduce="o => o.level" label="name">                                            
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label class="form-label">Láthatóság kezdete</label>
                         
                                    <div class="form-group">
                                        <input type="date" class="form-control" v-model="form.visible_from" :min="now">
                                    </div>
                            <div v-if="errors.visible_from" class="invalid-feedback d-block">{{ errors.visible_from[0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label class="form-label">Láthatóság vége</label>
                            <div class="form-group">
                                <input type="date" class="form-control" v-model="form.visible_to" :min="now">
                            </div>
                            <div v-if="errors.visible_to" class="invalid-feedback d-block">{{
            errors.visible_to[0] }}</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                        <div class="mb-3">
                            <label class="form-label">Felhasználók</label>
                            <v-select v-if="users" v-model="form.users" :options="users" :reduce="o => o.id" label="name"
                                :clearable="true" multiple>
                                <template #search="{ attributes, events }">
                                    <input class="vs__search" v-bind="attributes" v-on="events"
                                        :placeholder="form.users == null ? 'Mindenki' : ''" />
                                </template>
                            </v-select>
                            <loading mini v-else />
                            <div v-if="errors.users" class="invalid-feedback d-block">{{ errors.users[0] }}</div>
                        </div>
                    </div>
                </div>
            </div>
            </form>
        </b-modal>
    </span>
</template>

<script>
import SystemMessage from '../../../apis/SystemMessage';
import Loading from '../../../components/Loading';
import moment from 'moment';

export default {
    components: { Loading },
    props: ['mode', 'message','users'],
    data() {
        return {
            loading: false,
            form: {},
            errors: [],
            now: moment().format('YYYY-MM-DD'),
            priorities: JSON.parse(localStorage.getItem('constants')).priorities,
        }
    },
    created(){
        this.fillForm();
    },
    watch: {
        message(){
            this.fillForm();
        }
    },
    methods: {
        closeMessageModal() {
            this.$bvModal.hide('messageModal' + this._uid)
        },
        formHandler(bvModalEvt) {
            if (bvModalEvt) { //ok gombra van csak event
                bvModalEvt.preventDefault();
            }


            let methodToCall;
            let methodArguments;


            if (this.mode === 'new') {
                methodToCall = SystemMessage.add;
                methodArguments = [this.form];
            } else if (this.mode === 'edit') {
                methodToCall = SystemMessage.update;
                methodArguments = [this.message.id, this.form];
            }

            methodToCall(...methodArguments).then(() => {
                this.closeMessageModal();
                if(this.mode == 'new'){
                    this.form = {
                        message: null,
                        priority: 1,
                        visible_from: null,
                        visible_to: null,
                        users: []
                    }
                }
            }).then(()=>{
                this.$emit('refresh');
            })
            .catch(error => {
                if (error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
            });
        },
        fillForm(){
            this.form = this.mode === 'new' ? {
                        message: null,
                        priority: 1,
                        visible_from: null,
                        visible_to: null,
                        users: []
                    } : this.message;
        }
    }
}
</script>